export enum RotationAngle {
  None = 0,
  Ninety = 1,
  OneEighty = 2,
  TwoSeventy = 3
}
